// extracted by mini-css-extract-plugin
module.exports = {"installerModalForm":"managerInfo_installerModalForm__1vYxL","leftModalItem":"managerInfo_leftModalItem__28p6P","rightModalItem":"managerInfo_rightModalItem__nKFuY"};